import * as React from "react";

function Reports({color="var(--color-blue-500)",...props}) {
  return (
    <svg width="1.7em" height="1.7em" viewBox="0 0 24 25" fill="none" {...props}>
      <path
        d="M3 7.922a4 4 0 014-4h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4v-10z"
        stroke={color}
        strokeWidth={1.5}
      />
      <path
        d="M8 14.922v2M16 8.922v8M12 11.922v5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Reports;
